import React from "react";
import RightModal from "../Components/Modals/RightModal/RightModal";
import ProspectsViewContent from "../Components/Prospects/ProspectsViewContent";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";

const ProspectsView = () => {
  return (
    <ViewScroller>
      <div className="w100 d-flex flex-column gap-4 h-100">
        <ProspectsViewContent />
        <RightModal width={69} />
      </div>
    </ViewScroller>
  );
};

export default ProspectsView;
